import React from 'react';
import styled from 'styled-components';
import { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';

const Label = styled.label`
  font-weight: bold;
  color: #333;
`;

const Textarea = styled.textarea`
  width: 100%;
  height: 300px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 2rem;
  font-weight: 400;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
`;

interface ImageUploadControlProps {
  data: string;
  handleChange: (path: string, value: string) => void;
  path: string;
  id: any;
  label: any;
}

const CustomDetailsLarge: React.FC<ImageUploadControlProps> = ({
  data, // Provide a default value of an empty string if data is undefined
  handleChange,
  path,
  id,
  label,
}) => {
  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    handleChange(path, event.target.value);
  };

  console.log(data);

  return (
    <div>
      {/* <Label htmlFor={id}>{'Customer Story'}</Label> */}
      <Textarea
        placeholder={`${label}...`}
        id={id}
        value={data}
        onChange={handleTextareaChange}
      />
    </div>
  );
};

export default withJsonFormsControlProps(CustomDetailsLarge);
